// extracted by mini-css-extract-plugin
export default {"button":"Icon_button__Apeju","a":"Icon_a__s+nQW"};